import { Heading, IndeterminateSpinner } from '@portal/components'
import React from 'react'

export default function ResultsLoading() {
  return (
    <div
      className="flex h-full w-full flex-col items-center justify-center gap-1"
      data-testid="resultsLoading"
    >
      <IndeterminateSpinner className="h-12 w-12" />
      <Heading level={3} className="mb-0">
        Running query
      </Heading>
      <p className="text-gray-600 dark:text-gray-400">
        Your results will appear here
      </p>
    </div>
  )
}
